import {AppBar, Button, Hidden, IconButton, MenuItem, Select, Theme, Toolbar, Typography} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import {useLocale} from '../../../i18n/I18nProvider';
import logoutUser from '../logoutUser.api';

const logo = require('../../../../assets/img/logo.png');

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    boxShadow: 'none'
  },
  flexGrow: {
    flexGrow: 1
  },
  signOutButton: {
    marginLeft: theme.spacing(1)
  },
  logo: {
    height: 'auto',
    width: '132px',
  },
  topbar: {
    padding: '20px',
    justifyContent: 'flex-end',
    [theme.breakpoints.up('md')]: {
      paddingLeft: '48px',
      flexWrap: 'wrap',
    }
  },
  localeSelect: {
    margin: theme.spacing(1),
    minWidth: 60,
    color: theme.palette.white,
    '&:before': {
      borderColor: theme.palette.white,
    },
    '&:after': {
      borderColor: theme.palette.white,
    }
  },
  icon: {
    // borderColor: theme.palette.white,
    // color: theme.palette.white,
    fill: theme.palette.white,
  },
}));

const Topbar = (props: {className?: string, onSidebarOpen?: () => any}) => {
  const { className, onSidebarOpen, ...rest } = props;

  const classes = useStyles();
  const [sendLogoutUser] = logoutUser();
  const {locale, setLocale} = useLocale();

  const handleLogout = (event: any) => {
    sendLogoutUser();
    event.preventDefault();
  };

  const handleChangeLocale = (event: any) => {
    setLocale(event.target.value);
  };

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Toolbar className={classes.topbar}>
        <RouterLink to="/">
          <img
            className={classes.logo}
            alt="Logo"
            src={logo}
          />
        </RouterLink>
        <div className={classes.flexGrow} />

        <Select
            id="demo-simple-select"
            value={locale}
            onChange={handleChangeLocale}
            className={classes.localeSelect}
            inputProps={{
              classes: {
                icon: classes.icon,
              },
            }}
        >
          <MenuItem value="en">En</MenuItem>
          <MenuItem value="es">Es</MenuItem>
        </Select>

        <Button
            className={classes.signOutButton}
            color="inherit"
            onClick={handleLogout}
        >
          <Typography variant={'body1'} style={{color: 'white'}}>logout</Typography>
        </Button>

        <Hidden lgUp>
          <IconButton
              color="inherit"
              onClick={onSidebarOpen}
          >
            <MenuIcon/>
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
